import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SidebarState {
  isMainOpen = false;
  isCrmOpen = false;
  isIgniteOpen = false;
  isAdminOpen = false;
  isCrmAdminOpen = false;
}
